// * IMPORTANT: This file was generated by shadcn. Do not change
// * it manually unless you absolutely know what you are doing.

import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  // Added `autoExpand` prop.
  React.ComponentProps<"textarea"> & { autoExpand?: boolean }
>(({ autoExpand, className, value, ...props }, ref) => {
  // Added `internalRef` to handle the potential auto expand.
  const internalRef = React.useRef<HTMLTextAreaElement>(null);

  // Added `useImperativeHandle` to expose the internal ref instead.
  React.useImperativeHandle(ref, () => {
    if (!internalRef.current) {
      throw new Error('Internal textarea ref is not available');
    }
    return internalRef.current;
  }, []);

  // Added `useEffect` to handle the potential auto expand.
  React.useEffect(() => {
    if (autoExpand) {
      const textarea = internalRef.current;
      if (textarea) {
        textarea.style.height = 'auto';
        textarea.style.height = `${textarea.scrollHeight.toString()}px`;
      }
    }
  }, [autoExpand, value])
  
  return (
    <textarea
      className={cn(
        // Removed `focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2`.
        "flex min-h-[80px] w-full rounded-md border border-slate-200 bg-white px-3 py-2 text-base ring-offset-white placeholder:text-slate-500 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm dark:border-slate-800 dark:bg-slate-950 dark:ring-offset-slate-950 dark:placeholder:text-slate-400 dark:focus-visible:ring-slate-300",
        className
      )}
      ref={internalRef}
      value={value}
      {...props}
    />
  )
})
Textarea.displayName = "Textarea"

export { Textarea }
